import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { QualidadeService } from '@/core/api/sicom-api/registro/medico/qualidade/qualidade.service';
import { QualidadeCompletudeUf } from '@/core/api/sicom-api/registro/medico/qualidade/qualidade-completude.model';
import { QualidadeRadarPrazo } from '@/core/api/sicom-api/registro/medico/qualidade/qualidade-radar-prazo.model';
import { QualidadeSnapshot } from '@/core/api/sicom-api/registro/medico/qualidade/qualidade-snapshot.model';
import { CustomService } from '@/shared/services/custom.service';

@Injectable({ providedIn: 'root' })
export class QualidadeFeatureService extends CustomService {
    constructor(private core: QualidadeService) {
        super();
    }

    consultarCompletude(uf?: string): Observable<QualidadeCompletudeUf[]> {
        return this.core.consultarCompletude(uf).pipe(catchError(this.handleError));
    }

    consultarRadarPrazos(uf?: string): Observable<QualidadeRadarPrazo[]> {
        return this.core.consultarRadarPrazos(uf).pipe(catchError(this.handleError));
    }

    capturarSnapshots(uf?: string): Observable<QualidadeSnapshot[]> {
        return this.core.capturarSnapshots(uf).pipe(catchError(this.handleError));
    }

    consultarSnapshots(indicador: string, uf?: string): Observable<QualidadeSnapshot[]> {
        return this.core.consultarSnapshots(indicador, uf).pipe(catchError(this.handleError));
    }
}
